// extracted by mini-css-extract-plugin
module.exports = {"root":"EnquiryPanel_root__3t04V","heading":"EnquiryPanel_heading__3rbgz","contactForm":"EnquiryPanel_contactForm__2ZfCP"};